<div class="user-creation-card">
  @if (showMessage) {
    <div class="alert alert-success">
      {{ successMessage }}
      <button mat-icon-button (click)="hideMessage()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  @if (userFormGroup) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          <h1>Create New User</h1>
        </mat-card-title>
        <mat-card-subtitle>
          <p>Fill in the details below to create a new user account.</p>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <form
          class="user-form"
          [formGroup]="userFormGroup"
          (submit)="editUser()"
          autocomplete="off"
        >
          <section class="form-section">
            <h2>Personal Information</h2>
            <div class="form-columns">
              <mat-form-field appearance="outline" class="form-column-field">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="first_name" />
              </mat-form-field>
              @if (
                first_name.invalid && (first_name.dirty || first_name.touched)
              ) {
                <div class="alert alert-danger">First name is required</div>
              }
              <mat-form-field appearance="outline" class="form-column-field">
                <mat-label>Surname</mat-label>
                <input matInput formControlName="surname" />
              </mat-form-field>
              @if (surname.invalid && (surname.dirty || surname.touched)) {
                <div class="alert alert-danger">Surname is required</div>
              }
            </div>

            <div class="form-columns">
              <mat-form-field appearance="outline" class="form-column-field">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  formControlName="email"
                  (keyup)="checkEmail($event)"
                />
              </mat-form-field>
              <mat-form-field appearance="outline" class="form-column-field">
                <mat-label>Job Title</mat-label>
                <input matInput formControlName="job_title" type="text" />
              </mat-form-field>
            </div>

            <div class="form-columns" formGroupName="mobile">
              <mat-form-field appearance="outline" class="form-column-field">
                <mat-label>Mobile</mat-label>
                <input matInput formControlName="phone_number" />
              </mat-form-field>
              <mat-form-field appearnance="outline" class="form-column-field">
                <mat-label>Landline</mat-label>
                <input matInput formControlName="phone_number" />
              </mat-form-field>
            </div>
          </section>
          <section class="form-section">
            <h2>Account Details</h2>
            <mat-form-field appearance="outline" class="full-width-field">
              <mat-label>Username</mat-label>
              <input matInput formControlName="username" />
            </mat-form-field>
            @if (username.invalid && (username.dirty || username.touched)) {
              <div class="alert alert-danger">Username is required</div>
            }
            <mat-form-field appearance="outline" class="full-width-field">
              <mat-label>Password</mat-label>
              <input
                matInput
                formControlName="password"
                type="password"
                autocomplete="off"
              />
            </mat-form-field>
            @if (password.invalid && (password.dirty || password.touched)) {
              <div class="alert alert-danger">Password is required</div>
            }
            <div class="form-columns">
              <mat-form-field appearance="outline" class="form-column-field">
                <mat-label>Select Group</mat-label>
                <app-select-user-group
                  formControlName="group"
                ></app-select-user-group>
              </mat-form-field>
              <div class="form-column-field">
                <label>Signature: </label>
                <input
                  type="file"
                  formControlName="signature_image"
                  (change)="signature_preview($event)"
                  #signature
                  autocomplete="off"
                />
                @if (signature_image) {
                  <div class="signature-preview">
                    <img
                      [src]="signature_url"
                      style="dispaly: inline-block; max-width: 200px"
                    />
                  </div>
                }
              </div>
            </div>
          </section>
        </form>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-flat-button>{{ buttonText }}</button>
      </mat-card-actions>
    </mat-card>
    <form [formGroup]="userFormGroup" (submit)="editUser()" autocomplete="off">
      @if (job_title.invalid && (job_title.dirty || job_title.touched)) {
        <div class="alert alert-danger">Job title is required</div>
      }
      <div style="position: relative">
        @if (checkingEmail) {
          <div
            style="
              position: absolute;
              right: 0.25em;
              top: 0;
              text-align: center;
              display: flex;
              align-items: center;
            "
          >
            <mat-spinner [diameter]="16"></mat-spinner>
            <span
              style="
                font-size: 0.8em;
                display: inline-block;
                padding-left: 0.5em;
              "
              >Checking ...</span
            >
          </div>
        }
      </div>
      @if (email.invalid && (email.dirty || email.touched)) {
        <div class="alert alert-danger">Email is required</div>
      }
      @if (email.hasError("emailNotAvailable")) {
        <div class="alert alert-danger">
          {{ email.getError("emailNotAvailable") }}
        </div>
      }
      <div formGroupName="mobile">
        @if (
          mobile.controls.phone_number.invalid &&
          (mobile.controls.phone_number.dirty ||
            mobile.controls.phone_number.touched)
        ) {
          <div class="alert alert-danger">Mobile is required</div>
        }
      </div>
      <div formGroupName="landline">
        @if (
          mobile.controls.phone_number.invalid &&
          (mobile.controls.phone_number.dirty ||
            mobile.controls.phone_number.touched)
        ) {
          <div class="alert alert-danger">Landline is required</div>
        }
      </div>
      <div></div>
      @if (group.invalid && (group.dirty || group.touched)) {
        <div class="alert alert-danger">User group is required</div>
      }
      <div class="form-action form-action-right"></div>
    </form>
  }
</div>
